// components/Sender/SenderResumeDialog.js
import React from "react";

export function SenderResumeDialog({ progress, runName, onChoose }) {
  const runSent = progress?.run_sent || 0;
  const blockLimits = progress?.block_limits || {};
  const updatedAt = progress?.updated_at;

  const blocksList = Object.entries(blockLimits)
    .sort((a, b) => parseInt(a[0], 10) - parseInt(b[0], 10))
    .map(([k, v]) => `блок #${k}: лимит ${v}`);

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.6)",
      backdropFilter: "blur(3px)", zIndex: 1200,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }}>
      <div style={{
        background: "#fff", borderRadius: 14, width: "100%",
        maxWidth: 640, display: "flex", flexDirection: "column",
        overflow: "hidden",
      }}>
        <div style={{ padding: "16px 20px",
                      borderBottom: "1.5px solid #e5e7eb" }}>
          <h3 style={{ margin: 0 }}>♻️ Найден сохранённый прогресс</h3>
        </div>

        <div style={{ padding: 20, fontSize: 14, lineHeight: 1.6,
                      color: "#374151" }}>
          У запуска <b>«{runName}»</b> есть локальный прогресс:
          <ul style={{ margin: "12px 0 12px 20px", padding: 0 }}>
            <li>уже отправлено: <b>{runSent}</b></li>
            {updatedAt && (
              <li>обновлено: <b>{String(updatedAt).slice(0, 16).replace("T", " ")}</b></li>
            )}
            {blocksList.length > 0 && (
              <li>
                сохранённые лимиты блоков:
                <ul style={{ margin: "4px 0 0 20px", padding: 0,
                             color: "#6b7280", fontSize: 13 }}>
                  {blocksList.map((l, i) => <li key={i}>{l}</li>)}
                </ul>
              </li>
            )}
          </ul>
          Продолжить с этого места или начать с нуля?
          <div style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>
            При «Продолжить» лимиты блоков НЕ пересчитываются.
          </div>
        </div>

        <div style={{ padding: "12px 20px", borderTop: "1.5px solid #e5e7eb",
                      display: "flex", justifyContent: "flex-end", gap: 8,
                      flexWrap: "wrap" }}>
          <button className="btn-cancel" onClick={() => onChoose(null)}>
            Отмена
          </button>
          <button className="btn-cancel"
                  style={{ color: "#b45309", borderColor: "#fde68a" }}
                  onClick={() => onChoose("fresh")}>
            🔁 Начать с нуля
          </button>
          <button className="btn-primary"
                  style={{ minWidth: 160 }}
                  onClick={() => onChoose("resume")}>
            ▶ Продолжить
          </button>
        </div>
      </div>
    </div>
  );
}